var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_21268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.78463 2.20583C10.0511 1.93933 10.4126 1.78961 10.7895 1.78961C11.1664 1.78961 11.5278 1.93933 11.7943 2.20583C12.0608 2.47232 12.2105 2.83377 12.2105 3.21066C12.2105 3.58754 12.0608 3.94899 11.7943 4.21549L7.89432 8.11543C7.82388 8.18586 7.73572 8.23594 7.63916 8.26038L5.09737 8.90269L5.73968 6.36093C5.76416 6.26422 5.81435 6.17595 5.88495 6.10546L9.78463 2.20583ZM12.3526 1.64752C12.1474 1.44223 11.9037 1.27939 11.6355 1.16829C11.3672 1.05718 11.0798 1 10.7895 1C10.4992 1 10.2117 1.05718 9.94349 1.16829C9.67528 1.27939 9.43158 1.44223 9.22631 1.64752L5.32632 5.54747C5.15532 5.71861 5.03377 5.9328 4.97453 6.16736L4.16989 9.35047C4.1531 9.41674 4.1538 9.48623 4.17193 9.55214C4.19006 9.61805 4.225 9.67812 4.27332 9.72648C4.32164 9.77483 4.38169 9.80981 4.44759 9.82798C4.5135 9.84615 4.58299 9.8469 4.64926 9.83015L7.83242 9.02584C8.06716 8.96647 8.28147 8.84469 8.45263 8.67343L12.3526 4.77348C12.7671 4.35894 13 3.79672 13 3.2105C13 2.62428 12.7671 2.06206 12.3526 1.64752ZM7.49263 2.48751C7.22544 2.44322 6.95505 2.42104 6.68421 2.42119C3.98105 2.42119 1.78947 4.61274 1.78947 7.31587C1.78947 10.019 3.98105 12.2105 6.68421 12.2105C9.38737 12.2105 11.5789 10.019 11.5789 7.31587C11.5785 7.04008 11.5564 6.7705 11.5126 6.50714L12.1758 5.84336C12.3015 6.31325 12.3684 6.8065 12.3684 7.31587C12.3684 10.4551 9.82347 13 6.68421 13C3.54495 13 1 10.4551 1 7.31587C1 4.17664 3.54495 1.63173 6.68421 1.63173C7.19326 1.63173 7.68684 1.69868 8.15642 1.82436L7.49263 2.48751Z",
    fill: "#2D6CDF",
    stroke: "#2D6CDF",
    strokeWidth: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_21268"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconActive);
export default __webpack_public_path__ + "static/media/icon-active.ed4066d95d4dced125599f1d31faaf8d.svg";
export { ForwardRef as ReactComponent };